import axios from "axios";
// import alert from "@/lang/AlertMessages.js";
// import label from "@/lang/StaticLabels.js";

export default {
  getSettingDropdown({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(data)
      .then((res) => {
        commit("setSettingDropdown", { path: data, data: res.data.data });
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })

      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getProvinces({ dispatch, commit }) {
    axios
      .get("dropDown/Provinces")
      .then((res) => {
        commit("setProvinces", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getCities({ dispatch, commit }, data) {
    axios
      .get("dropDown/Cities?provinceId=" + data)
      .then((res) => {
        commit("setCities", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getInternalUnits({ dispatch, commit }) {
    axios
      .get("dropDown/InternalUnit")
      .then((res) => {
        commit("setInternalUnits", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getRoles({ dispatch, commit }) {
    axios
      .get("dropDown/Roles")
      .then((res) => {
        commit("setRoles", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getTariffTypes({ dispatch, commit }) {
    axios
      .get("dropDown/TariffType")
      .then((res) => {
        commit("setTariffTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getVehicles({ dispatch, commit }) {
    axios
      .get("dropDown/Vehicle")
      .then((res) => {
        commit("setVehicles", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getSmsTemplates({ dispatch, commit }) {
    axios
      .get("DropDown/SmsTemplate")
      .then((res) => {
        commit("setSmsTemplates", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getCompanies({ dispatch, commit }) {
    axios
      .get("Account/Companies")
      .then((res) => {
        commit("setCompanies", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getFiscalYears({ dispatch, commit }, data) {
    axios
      .get("Account/FiscalYears?companyId=" + data)
      .then((res) => {
        commit("setFiscalYears", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getBooleans({ dispatch, commit }) {
    axios
      .get("DropDown/Boolean")
      .then((res) => {
        commit("setBooleans", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getAccountInfos({ dispatch, commit }) {
    axios
      .get("DropDown/AccountInfo")
      .then((res) => {
        commit("setAccountInfos", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getSubscribers({ dispatch, commit }) {
    axios
      .get("DropDown/Subscriber")
      .then((res) => {
        commit("setSubscribers", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getActivityGroups({ dispatch, commit }) {
    axios
      .get("DropDown/ActivityGroup")
      .then((res) => {
        commit("setActivityGroups", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getWaterBillPeriods({ dispatch, commit }) {
    axios
      .get("DropDown/WaterBillPeriod")
      .then((res) => {
        commit("setWaterBillPeriods", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getMeterReadings({ dispatch, commit }, data) {
    axios
      .get("DropDown/MeterReading?subscriberId=" + data)
      .then((res) => {
        commit("setMeterReadings", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getAutomationTypes({ dispatch, commit }) {
    axios
      .get("DropDown/AutomationType")
      .then((res) => {
        commit("setAutomationTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getServiceTypes({ dispatch, commit }) {
    axios
      .get("DropDown/ServiceType")
      .then((res) => {
        commit("setServiceTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getBillboards({ dispatch, commit }) {
    axios
      .get("DropDown/Billboard")
      .then((res) => {
        commit("setBillboards", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getBillboardRequestStatuses({ dispatch, commit }) {
    axios
      .get("DropDown/BillboardRequestStatus")
      .then((res) => {
        commit("setBillboardRequestStatuses", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getVehicleTypes({ dispatch, commit }) {
    axios
      .get("DropDown/VehicleType")
      .then((res) => {
        commit("setVehicleTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getAutomations({ dispatch, commit }) {
    axios
      .get("DropDown/Automation")
      .then((res) => {
        commit("setAutomations", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getPersonTypes({ dispatch, commit }) {
    axios
      .get("DropDown/PersonType")
      .then((res) => {
        commit("setPersonTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getTariffs({ dispatch, commit }, data) {
    axios
      .get("DropDown/Tariff?" + data)
      .then((res) => {
        commit("setTariffs", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getAccounts({ dispatch, commit }) {
    axios
      .get("DropDown/Account")
      .then((res) => {
        commit("setAccounts", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getProjects({ dispatch, commit }) {
    axios
      .get("DropDown/Project")
      .then((res) => {
        commit("setProjects", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getPaymentProcesses({ dispatch, commit }) {
    axios
      .get("DropDown/PaymentProcess")
      .then((res) => {
        commit("setPaymentProcesses", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getSetting({ dispatch, commit }) {
    axios
      .get("DropDown/Setting")
      .then((res) => {
        commit("setSetting", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
};
